import React from 'react';
import PropTypes from 'prop-types';
import Moment from 'react-moment';
import {
  Badge,
  Button,
  Card,
  CardHeader,
  CardBody,
  Collapse,
  Table,
} from 'reactstrap';
import AppComponent from './core/AppComponent';

class FacilityInvites extends AppComponent {
  constructor(props) {
    super(props);
    this.state = { isShowing: false };
  }

  toggleIsShowing = () => {
    this.setState({
      isShowing: !this.state.isShowing,
    });
  };

  render() {
    const { onRevokeInvite } = this.props;

    return (
      <Card className="client-container" color="light">
        <CardHeader style={this.state.isShowing ? {} : { borderBottom: 'none' }}>
          <p className="mb-0 float-left">
            <Button color="link" className="text-info" aria-expanded={this.state.isShowing} onClick={() => this.toggleIsShowing()}>
              Invites <span className={this.state.isShowing ? 'icon-chevron-down' : 'icon-chevron-right'} />
            </Button> <Badge pill color="secondary">{this.props.invites.length}</Badge>
          </p>
        </CardHeader>

        <Collapse isOpen={this.state.isShowing}>
          <CardBody>
            <Table className="nightingale-Clients-FilterTable">
              <thead>
                <tr>
                  <th>Email</th>
                  <th>Role</th>
                  <th>Sent</th>
                  <th />
                </tr>
              </thead>
              <tbody>
                {
                  this.props.invites.map(invite =>
                    (
                      <tr key={invite.token}>
                        <td>{invite.email}</td>
                        <td>{invite.role}</td>
                        <td><Moment fromNow interval={10000}>{invite.createdAt}</Moment></td>
                        <td className="text-right">
                          <Button
                            size="sm"
                            color="link"
                            onClick={() => onRevokeInvite(invite.token)}
                          >
                            Revoke
                          </Button>
                        </td>
                      </tr>
                    ))
                }
              </tbody>
            </Table>
          </CardBody>
        </Collapse>
      </Card>
    );
  }
}

FacilityInvites.propTypes = {
  invites: PropTypes.array.isRequired,
  onRevokeInvite: PropTypes.func.isRequired,
};

export default FacilityInvites;



// WEBPACK FOOTER //
// ./src/components/FacilityInvites.js